import React from "react";

const ITEMS = [
  "SIGO",
  "PASSAPORTE QUALIFICA",
  "CFOMP INTERNATIONAL",
  "ESCOLA DO MANOBRADOR",
];

export default function TrustMarquee() {
  const items = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <section
      className="border-y border-white/10 bg-black overflow-hidden py-6"
      data-testid="trust-marquee"
    >
      <div className="text-center text-[11px] uppercase tracking-[0.3em] text-zinc-500 mb-4 font-semibold">
        Certificação reconhecida por
      </div>
      <div className="flex overflow-hidden">
        <div className="flex animate-marquee shrink-0 gap-16 pr-16 items-center">
          {items.map((item, i) => (
            <span
              key={i}
              className="font-display text-2xl sm:text-3xl text-zinc-500 uppercase tracking-wider whitespace-nowrap flex items-center gap-3"
            >
              <span className="w-2 h-2 bg-yellow-400" aria-hidden="true" />
              {item}
            </span>
          ))}
        </div>
        <div
          aria-hidden="true"
          className="flex animate-marquee shrink-0 gap-16 pr-16 items-center"
        >
          {items.map((item, i) => (
            <span
              key={`b-${i}`}
              className="font-display text-2xl sm:text-3xl text-zinc-500 uppercase tracking-wider whitespace-nowrap flex items-center gap-3"
            >
              <span className="w-2 h-2 bg-yellow-400" />
              {item}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
